import Vue from 'vue'
import day6Resource from '@/resources/day6'
import dataBrowserResource from '@/resources/dataBrowser'

const mixin = {
  data: function () {
    return {
      isLoadingCharacter: false,
      isDeletingCharacter: false,
      // Character browser
      loadingCharacterData: null,
      loadingCharacterMessage: ''
    }
  },
  computed: {
    isUpdatingCharacter () {
      return this.isLoadingCharacter || this.isDeletingCharacter
    }
  },
  methods: {
    openCharacterBrowser () {
      if (!this.isAccountPaid) {
        this.paidFeatureDialog(day6Resource.characterBrowserPaidFeature)
        return
      }

      const characterBrowser = this.$refs.characterBrowser
      if (characterBrowser) {
        characterBrowser.refreshCharacter(this.changedIdSummary)
        this.changedIdSummary = ''
      }

      this.showDataBrowser = true
    },

    onCharacterDimensionsSaved () {
      if (!this.isAccountPaid) { return }

      const characterBrowser = this.$refs.characterBrowser
      // Not opened yet
      if (!characterBrowser) { return }

      if (this.dimensionsIdSummary) {
        characterBrowser.refreshCharacter(this.dimensionsIdSummary)
      } else {
        characterBrowser.requeryNew()
      }
    },

    onBrowserNewCharacter () {
      this.cancelPoseEstimate()

      this.showDataBrowser = false

      if (this.hasUnsavedChanges) {
        this.unityCloseModals()
        this.newCharacterSaveChangesDialog()
      } else {
        this.continueNewCharacter()
      }
    },
    async saveChangesNewCharacter () {
      await this.saveChanges()
      await this.continueNewCharacter()
    },
    async continueNewCharacter () {
      this.openBodyDimensions()
    },

    onBrowserLoadCharacter (characterData) {
      this.showDataBrowser = false

      if (characterData.idSummary === this.dimensionsIdSummary) {
        return
      }

      this.cancelPoseEstimate()

      this.loadingCharacterData = characterData
      if (this.hasUnsavedChanges) {
        this.unityCloseModals()
        this.loadCharacterSaveChangesDialog()
      } else {
        this.continueLoadingCharacter()
      }
    },
    async saveChangesLoadCharacter () {
      await this.saveChanges()
      await this.continueLoadingCharacter()
    },
    async continueLoadingCharacter () {
      if (!this.loadingCharacterData) { return }

      if (this.isLoadingCharacter) { return }
      this.isLoadingCharacter = true

      const { idSummary, name: characterName } = this.loadingCharacterData

      try {
        const idDimensions = await this.querySummaryIdDimensions(idSummary)
        if (idDimensions) {
          this.loadingCharacterMessage = dataBrowserResource.loadingCharacterMessage(characterName)
          this.openBodyDimensions(idDimensions)
        } else {
          Vue.logger.error(new Error('Character summary does not have dimensions?'))
        }
      } finally {
        this.loadingCharacterData = null
        this.isLoadingCharacter = false
      }
    },

    onCharacterDelete ({ idSummary, isDeleting, isDeleted }) {
      const isCurrentCharacter = idSummary === this.dimensionsIdSummary

      this.isDeletingCharacter = isDeleting && isCurrentCharacter

      if (isDeleted && isCurrentCharacter) {
        this.$router.replace({ name: 'day6-main' })
        this.openBodyDimensions('')
      }
    }
  }
}

export default mixin
